export default __webpack_public_path__ + "static/media/tuna-napoly.86226706.png";